import { useState, useEffect } from "react";
import { H3, Label } from "../Text";
import { toast } from "react-toastify";
import Circle from "../Animation/Circle";
import { Button } from "../Buttons";
import { Request } from "../../hooks/Request";
import TableComplete from "../Tables/TableComplete";
import { requestAuth } from "../services/RequestService";
import { useDialog } from "../../contexts/DialogContext";
import { DialogConfirmation } from "../Modal";
import { numberWithDecimals, roundDecimals } from "../../utils/validate";
import { FileManagerModal } from "./FileManagerModal";

const InputSubDataPayments = ({ field }) => {
  const { openDialog, dialogClose } = useDialog();

  const { data, loading, call } = Request({
    urlApi: `/dataSet/procedure/${field.id}/field/${field.fieldId}/subdata`,
  });

  const {
    data: dataOrdenDeCompra,
    loading: loadingTotal,
    call: callTotal,
  } = Request({
    urlApi: `/Procedure/${field.id}/dataValues?fieldnames=totalOrdenDeCompra&fieldnames=terminosPago&fieldnames=moneda`,
  });

  const totalOC = roundDecimals(
    parseFloat(dataOrdenDeCompra?.totalOrdenDeCompra || 0),
  );

  useEffect(() => {
    call();
    callTotal();
    callDocument();
  }, [field.id]);

  const {
    data: document,
    loading: loadDocument,
    call: callDocument,
  } = Request({
    urlApi: field.urlApi,
  });

  function handleForm(item) {
    const values = item.description2
      ? JSON.parse(item.description2) || null
      : null;
    openDialog(
      <div className="w-[600px] max-w-full">
        {loadDocument && (
          <FormAddDocument
            item={
              item
                ? {
                    ...item,
                    concept: item.label || "",
                    percentage: values?.percentage || "",
                    amount: item.numberValue || "",
                    tentativeDate: values?.tentativeDate || "",
                    description: item.description || "",
                    status: values?.status || "Planificado",
                    paymentDate: values?.paymentDate || "",
                  }
                : null
            }
            reload={call}
            field={field}
            totalOC={totalOC}
            dataOrdenDeCompra={dataOrdenDeCompra}
            onClose={dialogClose}
          />
        )}
        <br />
      </div>,
    );
  }

  function handleWorkflow(item) {
    const values = item.description2 ? JSON.parse(item.description2) : {};
    openDialog(
      <div className="w-[450px] max-w-full">
        <FormUpdateStatus
          item={item}
          currentStatus={values?.status || "Planificado"}
          values={values}
          reload={() => {
            call();
            dialogClose();
          }}
        />
      </div>,
    );
  }

  function handleDelete(data) {
    openDialog(
      <DialogConfirmation
        children={<H3>¿Estas seguro que quieres eliminar este item?</H3>}
        onClose={dialogClose}
        method="delete"
        url={`/dataSet/procedure/subData/${data.id}`}
        texBtn="Eliminar"
        handleSuccess={call}
      />,
    );
  }

  function handleFiles(item) {
    openDialog(
      <FileManagerModal item={item} reload={call} onClose={dialogClose} />,
    );
  }

  return (
    <div className="bg-gray-300/40 p-2 rounded-md">
      <div className="flex justify-between items-center">
        <Label htmlFor={field.name} className={`${field.className} my-0`}>
          {field.labelCustom ? field.labelCustom : field.label}
        </Label>
      </div>
      <div className="bg-gray-100 rounded-lg p-3 pt-2">
        {loadDocument && (
          <FormAddDocument
            reload={call}
            field={field}
            totalOC={totalOC}
            dataOrdenDeCompra={dataOrdenDeCompra}
            onClose={() => {}}
          />
        )}
      </div>
      <br />
      {!loading ? (
        <Circle />
      ) : (
        <div className="w-full">
          <TableComplete
            header={[
              {
                name: "index",
                label: "#",
              },
              {
                name: "label",
                label: "Concepto",
              },
              {
                name: "percentage",
                label: "%",
                type: "custom",
                builder: (_, __, item) => {
                  const values = item.description2
                    ? JSON.parse(item.description2)
                    : null;
                  return (
                    <h3 className="font-normal">
                      {values?.percentage || "0"}%
                    </h3>
                  );
                },
              },
              {
                name: "numberValue",
                label: "Monto",
                type: "custom",
                builder: (val, _, item) => {
                  const values = item.description2
                    ? JSON.parse(item.description2)
                    : null;
                  const isPaid = values?.status === "Pagado";
                  return (
                    <h3
                      className={`font-bold ${isPaid ? "text-green-600" : "text-blue-700"}`}
                    >
                      {numberWithDecimals(val || 0)}
                    </h3>
                  );
                },
              },
              /*               {
                name: "description",
                label: "Descripción",
              }, */
              {
                name: "status",
                label: "Estado",
                type: "custom",
                builder: (_, __, item) => {
                  const values = item.description2
                    ? JSON.parse(item.description2)
                    : null;
                  const status = values?.status || "Planificado";
                  const colors = {
                    Planificado: "bg-gray-100 text-gray-600",
                    Solicitado: "bg-amber-100 text-amber-700",
                    Pagado: "bg-green-600 text-white shadow-sm",
                  };
                  return (
                    <span
                      className={`px-2 py-0.5 rounded-full text-[10px] font-bold uppercase ${colors[status]}`}
                    >
                      {status}
                    </span>
                  );
                },
              },
              {
                name: "tentativeDate",
                label: "Fecha Estimada de Pago",
                type: "custom",
                builder: (_, __, item) => {
                  const values = item.description2
                    ? JSON.parse(item.description2)
                    : null;
                  return (
                    <h3 className="font-normal">
                      {values?.tentativeDate || "-"}
                    </h3>
                  );
                },
              },
              {
                name: "paymentDate",
                label: "Fecha de Pago",
                type: "custom",
                builder: (_, __, item) => {
                  const values = item.description2
                    ? JSON.parse(item.description2)
                    : null;
                  return (
                    <h3 className="font-normal">
                      {values?.paymentDate || "-"}
                    </h3>
                  );
                },
              },
              {
                name: "add",
                type: "action",
                label: "Opciones",
                sticky: true,
                actions: [
                  {
                    label: "Actualizar Estado",
                    icon: "fas fa-sync-alt",
                    action: handleWorkflow,
                    color: "text-amber-600",
                  },
                  {
                    label: "Documentos",
                    icon: "fas fa-paperclip",
                    action: handleFiles,
                    color: "text-purple-600",
                  },
                  {
                    label: "Editar",
                    icon: "fas fa-edit",
                    action: handleForm,
                    color: "text-[#1d4ed8]",
                  },
                  {
                    label: "Eliminar",
                    icon: "fas fa-trash",
                    action: handleDelete,
                    color: "text-red-500",
                  },
                ],
              },
            ]}
            data={data?.map((item, i) => ({ ...item, index: i + 1 }))}
          />
        </div>
      )}
    </div>
  );
};

const FormAddDocument = (props) => {
  const {
    item = null,
    reload,
    field,
    onClose,
    totalOC,
    dataOrdenDeCompra,
  } = props;

  const [values, setValues] = useState({
    concept: item?.concept ? item.concept : "",
    percentage: item?.percentage ? item.percentage : "",
    amount: item?.amount ? item.amount : "",
    tentativeDate: item?.tentativeDate ? item.tentativeDate : "",
    //
    status: item?.status ? item.status : "Planificado",
    paymentDate: item?.paymentDate || "",
  });

  useEffect(() => {
    if (values.percentage && totalOC > 0) {
      const p = parseFloat(values.percentage);
      const calcAmount = !isNaN(p) ? (totalOC * p) / 100 : "";
      setValues((prev) => ({
        ...prev,
        amount: calcAmount !== "" ? calcAmount.toFixed(2) : "",
      }));
    }
  }, [totalOC]);

  async function handleSubmit() {
    if (!values.concept) return toast.error("El concepto es obligatorio");

    const desc2 = {
      percentage: values.percentage,
      tentativeDate: values.tentativeDate,
      status: values.status,
      paymentDate: values.paymentDate,
    };
    await requestAuth(
      item ? "put" : "post",
      item
        ? `/dataSet/procedure/subData/${item.id}`
        : `/dataSet/procedure/${field.id}/field/${field.fieldId}/subdata`,
      {
        Label: values.concept,
        Description: values.description,
        NumberValue: parseFloat(values.amount) || 0,
        Description2: JSON.stringify({ ...desc2, concept: values.concept }),
      },
    )
      .then(() => {
        reload();
        onClose();
        setValues({
          concept: "",
          percentage: "",
          amount: "",
          tentativeDate: "",
          status: "Planificado",
          paymentDate: "",
          description: "",
        });
        toast.success("Registro exitoso");
      })
      .catch((err) => {
        console.error(err);
        toast.error("Se produjo un error al guardar");
      });
  }

  function handleChangeInp(e) {
    const { name, value } = e.target;
    const cleanValue = String(value).replace(/,/g, "");

    if (name === "percentage") {
      const p = parseFloat(cleanValue);
      const calcAmount = !isNaN(p) && totalOC > 0 ? (totalOC * p) / 100 : "";
      setValues((prev) => ({
        ...prev,
        percentage: value,
        amount: calcAmount !== "" ? calcAmount.toFixed(2) : "",
      }));
    } else if (name === "amount") {
      const a = parseFloat(cleanValue);
      const calcPercent = !isNaN(a) && totalOC > 0 ? (a * 100) / totalOC : "";
      setValues((prev) => ({
        ...prev,
        amount: value,
        percentage: calcPercent !== "" ? calcPercent.toFixed(2) : "",
      }));
    } else {
      setValues((a) => ({
        ...a,
        [name]: value,
      }));
    }
  }

  return (
    <div className="flex flex-col gap-4 p-4 bg-white rounded-lg shadow-md border border-blue-100">
      <H3 className="border-b pb-2 text-blue-700">
        {item ? "Editar Planificación" : "Nueva Planificación de Pago"}
      </H3>

      <div className="flex flex-col md:flex-row gap-4">
        <div className="flex-1 bg-white p-3 rounded border border-blue-100 shadow-sm">
          <span className="block text-xs font-bold text-gray-500 uppercase">
            Monto Total
          </span>
          <span className="block text-lg font-bold text-blue-700 mt-1">
            {numberWithDecimals(totalOC)}
          </span>
        </div>
        <div className="flex-[2] bg-white p-3 rounded border border-blue-100 shadow-sm">
          <span className="block text-xs font-bold text-gray-500 uppercase mb-1">
            Términos De Pago
          </span>
          {dataOrdenDeCompra?.category === "sub-tramite" &&
          dataOrdenDeCompra?.terminosPago === "null" ? (
            <span className="text-red-600 font-semibold">
              Llenar en el tramite principal.
            </span>
          ) : (
            <ul className="list-disc list-inside text-sm text-gray-700">
              <li>{dataOrdenDeCompra?.terminosPago || "No especificados"}</li>
            </ul>
          )}
        </div>
        <div className="flex-[2] bg-white p-3 rounded border border-blue-100 shadow-sm">
          <span className="block text-xs font-bold text-gray-500 uppercase mb-1">
            Moneda
          </span>

          <ul className="list-disc list-inside text-sm text-gray-700">
            <li>{dataOrdenDeCompra?.moneda || "No especificada"}</li>
          </ul>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <div>
          <Label className="my-0 mt-2">Concepto</Label>
          <input
            value={values.concept}
            onChange={handleChangeInp}
            className="w-full p-2 rounded-md border border-gray-300 uppercase"
            type="text"
            name="concept"
            placeholder="Ej: Pago Inicial"
          />
        </div>
        <div>
          <Label className="my-0 mt-2">Porcentaje (%)</Label>
          <input
            value={values.percentage}
            onChange={handleChangeInp}
            className="w-full p-2 rounded-md border border-gray-300"
            type="number"
            name="percentage"
            placeholder="0"
          />
        </div>
        <div>
          <Label className="my-0 mt-2">Monto</Label>
          <input
            value={
              values.amount ? numberWithDecimals(Number(values.amount)) : ""
            }
            onChange={handleChangeInp}
            className="w-full p-2 rounded-md border border-gray-300"
            type="text"
            name="amount"
            placeholder="0.00"
          />
        </div>
        <div>
          <Label className="my-0 mt-2">Fecha Tentativa</Label>
          <input
            value={values.tentativeDate}
            onChange={handleChangeInp}
            className="w-full p-2 rounded-md border border-gray-300"
            type="date"
            name="tentativeDate"
          />
        </div>
        <div className="md:col-span-2">
          {/* <Label className={`my-0 mt-2`}>Descripción</Label>
          <input
            value={values.description}
            onChange={handleChangeInp}
            className="w-full p-2 rounded-md border border-gray-300"
            type="text"
            name="description"
            placeholder="Descripción del pago"
          /> */}
        </div>
      </div>
      {item && (
        <div className="bg-blue-50 p-2 rounded text-xs text-blue-600 italic">
          Nota: Para adjuntar archivos, utilice el ícono del clip en la lista
          principal después de guardar los datos.
        </div>
      )}
      <div className="flex justify-end mt-2">
        <Button onClick={handleSubmit} className="px-6 py-2">
          {item ? "Actualizar" : "Guardar"}
        </Button>
      </div>
    </div>
  );
};

const FormUpdateStatus = ({ item, currentStatus, values, reload }) => {
  const [paymentDate, setPaymentDate] = useState(values?.paymentDate || "");

  async function update(newStatus, date = "") {
    const payload = {
      ...item,
      Description2: JSON.stringify({
        ...values,
        status: newStatus,
        paymentDate: date || values.paymentDate,
      }),
    };
    await requestAuth("put", `/dataSet/procedure/subData/${item.id}`, payload);
    toast.success(`Estado actualizado a ${newStatus}`);
    reload();
  }

  return (
    <div className="p-5 bg-white rounded-lg flex flex-col gap-4 shadow-xl">
      <H3 className="text-center">Flujo de Pago</H3>
      <div className="flex justify-between items-center px-4">
        <div
          className={`flex flex-col items-center ${currentStatus === "Planificado" ? "text-blue-600" : "text-gray-400"}`}
        >
          <div
            className={`w-8 h-8 rounded-full flex items-center justify-center border-2 ${currentStatus === "Planificado" ? "border-blue-600 font-bold" : "border-gray-300"}`}
          >
            1
          </div>
          <span className="text-[10px]">Planificado</span>
        </div>
        <div className="h-0.5 flex-grow bg-gray-200 mx-2"></div>
        <div
          className={`flex flex-col items-center ${currentStatus === "Solicitado" ? "text-blue-600" : "text-gray-400"}`}
        >
          <div
            className={`w-8 h-8 rounded-full flex items-center justify-center border-2 ${currentStatus === "Solicitado" ? "border-blue-600 font-bold" : "border-gray-300"}`}
          >
            2
          </div>
          <span className="text-[10px]">Solicitado</span>
        </div>
        <div className="h-0.5 flex-grow bg-gray-200 mx-2"></div>
        <div
          className={`flex flex-col items-center ${currentStatus === "Pagado" ? "text-blue-600" : "text-gray-400"}`}
        >
          <div
            className={`w-8 h-8 rounded-full flex items-center justify-center border-2 ${currentStatus === "Pagado" ? "border-blue-600 font-bold" : "border-gray-300"}`}
          >
            3
          </div>
          <span className="text-[10px]">Pagado</span>
        </div>
      </div>

      <div className="mt-4 border-t pt-4">
        {currentStatus === "Planificado" && (
          <Button
            onClick={() => update("Solicitado")}
            className="w-full bg-amber-500 hover:bg-amber-600"
          >
            Marcar como SOLICITADO
          </Button>
        )}
        {currentStatus === "Solicitado" && (
          <div className="flex flex-col gap-2">
            <Label>Registrar Fecha de Pago Real:</Label>
            <input
              type="date"
              className="p-2 border rounded"
              value={paymentDate}
              onChange={(e) => setPaymentDate(e.target.value)}
            />
            <Button
              disabled={!paymentDate}
              onClick={() => update("Pagado", paymentDate)}
              className="w-full bg-green-600"
            >
              Confirmar PAGO REALIZADO
            </Button>
          </div>
        )}
        {currentStatus === "Pagado" && (
          <p className="text-center text-green-600 font-bold italic">
            Este pago ya ha sido procesado completamente.
          </p>
        )}
      </div>
    </div>
  );
};

export default InputSubDataPayments;
